import http from '../../../../api/http';
import type { PlanCuenta } from '../types/planCuenta';

const ENDPOINTS = {
  BASE: '/contabilidad/plan-cuentas',
};

export class PlanCuentaService {
  public static async getAll(): Promise<PlanCuenta[]> {
    const response = await http.get(ENDPOINTS.BASE);
    return response.data;
  }

  public static async getById(id: number): Promise<PlanCuenta> {
    const response = await http.get(`${ENDPOINTS.BASE}/${id}`);
    return response.data;
  }

  public static async getByCodigo(codigo: string): Promise<PlanCuenta> {
    const response = await http.get(`${ENDPOINTS.BASE}/codigo/${codigo}`);
    return response.data;
  }

  public static async getByNivel(nivel: number): Promise<PlanCuenta[]> {
    const response = await http.get(`${ENDPOINTS.BASE}/nivel/${nivel}`);
    return response.data;
  }

  public static async getCuentasMovimiento(): Promise<PlanCuenta[]> {
    const response = await http.get(`${ENDPOINTS.BASE}/movimiento`);
    return response.data;
  }

  public static async save(cuenta: Partial<PlanCuenta>): Promise<PlanCuenta> {
    const response = await http.post(ENDPOINTS.BASE, cuenta);
    return response.data;
  }

  public static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINTS.BASE}/${id}`);
  }
}
